import { render, staticRenderFns, recyclableRender, components } from "./new_report.vue?vue&type=template&id=662b0166&scoped=true&"
var renderjs
import script from "./new_report.vue?vue&type=script&lang=js&"
export * from "./new_report.vue?vue&type=script&lang=js&"
import style0 from "./new_report.vue?vue&type=style&index=0&lang=css&"
import style1 from "./new_report.vue?vue&type=style&index=1&id=662b0166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662b0166",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/new_report/new_report.vue"
export default component.exports